<template>
  <el-container class="chat-page">
    <div style="width: 320px;height: 18px;background-color: white;position: absolute;right: 0;bottom: 0;z-index: 1;"></div>
    <el-aside width="260px" class="aside">
      <div class="header" style="position: relative;">
          <img src="../assets/image/icon_Search@2x.png" alt="" class="search-icon" style="width: 20px;height: 20px;position: absolute;z-index: 1;left: 25px;top: 15px;">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText" style="padding-left: 26px;">
          <!-- <i class="el-icon-search el-input__icon" slot="prefix"> </i> -->
          <!-- <img src="../assets/image/icon_Search@2x.png" alt="" class="search-icon" style="width: 20px;height: 20px;"> -->
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <el-scrollbar class="chat-items" v-else>
        <div v-for="(chat, index) in chatStore.chats" :key="index">
          <chat-item v-show="!chat.delete && chat.showName && chat.showName.includes(searchText)" :chat="chat"
            :index="index" @click.native="onActiveItem(index)" @delete="onDelItem(index)" @top="onTop(index)"
            :active="chat === chatStore.activeChat"></chat-item>
        </div>
      </el-scrollbar>
    </el-aside>
    <el-container>
      <chat-box v-if="chatStore.activeChat" :chat="chatStore.activeChat"></chat-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: []
    }
  },
  methods: {
    onActiveItem(index) {
      this.$store.commit("activeChat", index);
    },
    onDelItem(index) {
      this.$store.commit("removeChat", index);
    },
    onTop(chatIdx) {
      this.$store.commit("moveTop", chatIdx);
    },
    // 自动选择第一个聊天
    autoSelectFirstChat() {
      const chats = this.chatStore.chats.filter(chat => !chat.delete);
      if (chats.length > 0 && !this.chatStore.activeChat) {
        // 找到第一个未删除的聊天在原始数组中的索引
        const firstChat = chats[0];
        const originalIndex = this.chatStore.chats.findIndex(chat => 
          chat === firstChat
        );
        if (originalIndex !== -1) {
          this.$store.commit("activeChat", originalIndex);
        }
      }
    }
  },
  computed: {
    chatStore() {
      return this.$store.state.chatStore;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg
    }
  },
  mounted() {
    // 组件挂载时检查是否需要自动选择第一个聊天
    this.$nextTick(() => {
      if (!this.loading && this.chatStore.chats.length > 0 && !this.chatStore.activeChat) {
        this.autoSelectFirstChat();
      }
    });
  },
  watch: {
    // 监听加载状态和聊天列表变化
    loading(newVal, oldVal) {
      // 当从加载状态变为非加载状态时，检查是否需要自动选择第一个聊天
      if (oldVal && !newVal) {
        this.autoSelectFirstChat();
      }
    },
    // 监听聊天列表变化
    'chatStore.chats': {
      handler(newChats) {
        // 当聊天列表有数据且没有活跃聊天时，自动选择第一个
        if (newChats && newChats.length > 0 && !this.chatStore.activeChat && !this.loading) {
          this.autoSelectFirstChat();
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-page::v-deep {

  .aside {
    display: flex;
    flex-direction: column;
    background: var(--im-background);
    border-right: 1px solid rgba(217, 220, 224, 1);
    .header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 16px;
    }

    .chat-loading {
      height: 50px;
      background-color: #eee;
      background-color: white !important;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }
    }

    .header {
      background-color: #f3f3f3 !important;

      .search-text.el-input {
        background-color: #EAEAEA  !important;
        border-radius: 4px;
        .el-input__inner{
          background-color: #EAEAEA  !important;
          border: none;
          color: #333 !important;
          border-radius: 4px;
          outline: none;
          &::placeholder {
            color: #9E9E9E !important;
            opacity: 1;
          }
        }
      }
    }

    .chat-items.el-scrollbar {
      flex: 1;
      background-color: #F3F3F3  !important;

      .el-scrollbar__wrap {
        background-color: #F3F3F3 !important;

        .el-scrollbar__view {
          background-color: #F3F3F3 !important;

          // .chat-item {
          //   background-color: #F3F3F3  !important;
          // }
          // .active{
          //   background-color: #F3F3F3 !important;
          // }
        }
      }
    }
  }
}
</style>
